const localePt = {
  // Error view
  UDE_BUNDLES_ERROR: 'Ocorreu um erro ao obter suas certificações',
  // Bundle card
  UDE_BUNDLE_COMPLETED: 'Certificação concluída',
};
export default localePt;
